import React from "react";
import clsx from "clsx";
import { Icons, Chip, Typography } from "@curves/ui-base";
import CustomerNameLabel from "@icoach/nonMember/components/CustomerNameLabel";
import { NonMemberDescribeLabelBox } from "@icoach/nonMember/components/";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
import { parseDate } from "@util/moment";
import { isEmpty, isEqual } from "@util/utils";
import { NON_MEMBER_TEMPORARY_INFO_PAGE, CUSTOMER_TYPE, TARGET_TYPE } from "@constants/";

// 顧客Table欄位
const getCustomerRowsLabel = () => [
	{
		cellKey: "customerID",
		headerLabel: "",
		isIcon: true,
		formatCell: (cellValue, rowData, { Checkbox }) => {
			return <Checkbox value={cellValue} />;
		},
	},
	{
		cellKey: "customerID",
		headerLabel: "顧客",
		width: 14,
		maxWidth: 22,
		align: "left",
		formatCell: (cellValue, rowData, { isRevealed, domKeyName }) => {
			return <CustomerNameLabel sourceData={rowData} isRevealed={isRevealed} domProps={{ [domKeyName]: cellValue }} />;
		},
	},
	{
		cellKey: "sourceTypeText",
		headerLabel: "來源",
		width: 12,
		maxWidth: 12,
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="warning" />;
		},
	},
	{
		cellKey: "requiredTypeText",
		headerLabel: "需求",
		width: 12,
		maxWidth: 12,
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="success" />;
		},
	},
	{
		cellKey: "statusText",
		headerLabel: "狀態",
		width: 12,
		maxWidth: 12,
		align: "center",
		formatCell: (cellValue, rowData) => {
			const isInvalid = isEqual(rowData.status, 2);
			return <Chip label={cellValue} color={clsx(isInvalid ? "gray" : "info")} />;
		},
	},
	{
		cellKey: "contact",
		headerLabel: "聯繫紀錄",
		width: 30,
		maxWidth: 30,
		align: "left",
		formatCell: (cellValue, { customerID }, { nonMemberDescribeLabelBoxRef }) => {
			return !isEmpty(cellValue) ? <NonMemberDescribeLabelBox ref={nonMemberDescribeLabelBoxRef} {...cellValue} targetID={customerID} peopleType={"1"} /> : "";
		},
	},
	{
		cellKey: "introducer",
		headerLabel: "介紹人",
		align: "center",
		style: { width: 100 },
	},
	{
		cellKey: "askDate",
		headerLabel: "詢問日期",
		align: "center",
		formatCell: cellValue => {
			return (
				<Typography variant={"body1"} className={"mb-0"}>
					{parseDate(cellValue, "YYYY/MM/DD")}
				</Typography>
			);
		},
	},
];

// 名單 Table欄位
const getProspectRowsLabel = () => [
	{
		cellKey: "customerID",
		headerLabel: " ",
		isIcon: true,
		formatCell: (cellValue, rowData, { Checkbox }) => {
			return <Checkbox value={cellValue} />;
		},
	},
	{
		cellKey: "customerID",
		headerLabel: "名單",
		width: 14,
		maxWidth: 22,
		align: "left",
		formatCell: (cellValue, rowData, { isRevealed, domKeyName }) => {
			return <CustomerNameLabel sourceData={rowData} isRevealed={isRevealed} domProps={{ [domKeyName]: cellValue }} />;
		},
	},
	{
		cellKey: "sourceTypeText",
		headerLabel: "來源",
		maxWidth: 8,
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="warning" />;
		},
	},
	{
		cellKey: "requiredTypeText",
		headerLabel: "需求",
		maxWidth: 8,
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="success" />;
		},
	},
	{
		cellKey: "contact",
		headerLabel: "聯繫紀錄",
		width: 30,
		maxWidth: 30,
		align: "left",
		formatCell: (cellValue, { customerID }, { nonMemberDescribeLabelBoxRef }) => {
			return !isEmpty(cellValue) ? <NonMemberDescribeLabelBox ref={nonMemberDescribeLabelBoxRef} {...cellValue} targetID={customerID} peopleType={"1"} /> : "";
		},
	},
	{
		cellKey: "introducer",
		headerLabel: "介紹人",
		style: { width: 150 },
		align: "center",
	},
	{
		cellKey: "registrationDate",
		headerLabel: "登錄日期",
		align: "center",
		formatCell: cellValue => {
			return (
				<Typography variant={"body1"} className={"mb-0"}>
					{parseDate(cellValue, "YYYY/MM/DD")}
				</Typography>
			);
		},
	},
];

// 暫存名單 Table欄位
const getTemporaryRowsLabel = () => [
	{
		cellKey: "temporaryID",
		headerLabel: "",
		isIcon: true,
		formatCell: (cellValue, rowData, { Checkbox }) => {
			return <Checkbox value={cellValue} />;
		},
	},
	{
		cellKey: "name",
		headerLabel: "標題",
		style: { width: 350 },
	},
	{
		cellKey: "createdDate",
		headerLabel: "建立日期",
		style: { width: 170 },
		formatCell: cellValue => parseDate(cellValue, "YYYY-MM-DD HH:mm:ss"),
	},
	{
		cellKey: "customerTypeText",
		headerLabel: "篩選名單",
		style: { width: 150 },
	},
	{
		cellKey: "count",
		headerLabel: "筆數",
		align: "center",
		style: { width: 80 },
	},
];

// 顧客/名單 使用
const menuNonMemberActions = ({ dialogRef, onAddInvalidData, onDeleteData, onAddInvalidRefresh, onDeleteRefresh, onAppointmentClick, onContactRefresh }) => [
	{
		label: "編輯",
		icon: <Icons.Edit />,
		to: ({ customerID, customerType }) => {
			if (customerType === CUSTOMER_TYPE.GUEST) return NON_MEMBER_ROUTER.PROSPECT.GET_INFO_PATH(customerID);
			else return NON_MEMBER_ROUTER.CUSTOMER.GET_INFO_PATH(customerID);
		},

		onClick: null,
	},
	{
		label: "新增預約",
		icon: <Icons.Assignment />,
		to: null,
		onClick: ({ customerID }) => onAppointmentClick(customerID),
	},
	{
		label: "發送簡訊",
		icon: <Icons.PaperPlane />,
		to: null,
		onClick: sourceData => dialogRef.current.openNonMemberSmsDialog({ id: sourceData.customerID, name: sourceData.name, type: TARGET_TYPE.CUSTOMER }),
	},
	{
		label: "新增聯繫",
		icon: <Icons.Phone />,
		to: null,
		onClick: ({ customerID }, { nonMemberDescribeLabelBoxRef }) => {
			dialogRef.current.openNonMemberNoMemberContact({ peopleID: customerID, setContractLabelRef: nonMemberDescribeLabelBoxRef }, onContactRefresh);
		},
	},
	{
		label: "加入無效",
		icon: <Icons.UserSlash />,
		to: null,
		onClick: ({ customerID }) => {
			const arr = [customerID].map(Number);
			dialogRef.current.openNonMemberAddInvalid(onAddInvalidData(arr), onAddInvalidRefresh);
		},
	},
	{
		label: "刪除",
		icon: <Icons.Trash />,
		to: null,
		onClick: ({ customerID }) => {
			const arr = [customerID].map(Number);
			dialogRef.current.openNonMemberRemoveContractRecord(onDeleteData(arr), onDeleteRefresh);
		},
	},
];

// 暫存名單使用
const menuTemporaryActions = ({ dialogRef, onDeleteData, onDeleteRefresh, onExcelClick }) => [
	{
		label: "查看",
		icon: <Icons.Edit />,
		to: ({ temporaryID, customerType }) => {
			const type = NON_MEMBER_TEMPORARY_INFO_PAGE[customerType];
			return NON_MEMBER_ROUTER.TEMPORARIES.GET_ENTITY_PATH(type, temporaryID);
		},
		onClick: null,
	},
	{
		label: "發送簡訊",
		icon: <Icons.PaperPlane />,
		to: null,
		onClick: ({ temporaryID }) => {
			dialogRef.current.openNonMemberSmsDialog({ affixParams: { temporaryID } }, null, true);
		},
	},
	{
		label: "匯出Excel",
		icon: <Icons.File />,
		to: null,
		onClick: ({ temporaryID }) => onExcelClick(temporaryID),
	},
	{
		label: "刪除",
		icon: <Icons.Trash />,
		to: null,
		onClick: ({ temporaryID }) => {
			const arr = [temporaryID].map(Number);
			dialogRef.current.openNonMemberTemporaryDeleteRecord(onDeleteData(arr), onDeleteRefresh);
		},
	},
];

/**
 * @param {string} input
 * return [string]
 */
const splitText = input => {
	return input.split("&").flatMap(part => {
		const [, value] = part.split(":");
		return value.split(",").map(v => v.trim());
	});
};

export { getCustomerRowsLabel, getProspectRowsLabel, getTemporaryRowsLabel, menuNonMemberActions, menuTemporaryActions, splitText };
